import Swiper from "swiper";
import nextSvg from "../../../assets/svg/arrow-right-alt.svg";
import prevSvg from "../../../assets/svg/arrow-left-alt.svg";
document.querySelectorAll('iframe[src*="youtube.com"]').forEach((iframe) => {
	const src = iframe.getAttribute("src");
	if (src && !src.includes("enablejsapi=1")) {
		const url = new URL(src, window.location.origin);
		url.searchParams.set("enablejsapi", "1");
		iframe.setAttribute("src", url.toString());
	}
});
export default Array.from(
	document.querySelectorAll(".timeline-slider > .timeline-slider__slides")
).map((slider) => {
	const wrapper = slider.querySelector(".timeline-slider__slides-wrap");
	const slides = wrapper.querySelectorAll(".timeline-slider__slide");

	if (!wrapper || !slides) {
		return;
	}

	slider.classList.add("swiper-container");
	slider.setAttribute("tabindex", "0");
	slider.setAttribute(
		"aria-label",
		"Timeline slider, use left and right arrows to navigate"
	);
	wrapper.classList.add("swiper-wrapper");
	slides.forEach((slide) => slide.classList.add("swiper-slide"));

	// Create a container for slide titles and dots below the slides
	const titleNavContainer = document.createElement("div");
	titleNavContainer.classList.add("timeline-slider__titles-nav");

	// const progressBar = document.createElement("div");
	// progressBar.classList.add("timeline-slider__progress-bar");
	// titleNavContainer.prepend(progressBar);
	// const progressBarFill = document.createElement("div");
	// progressBarFill.classList.add("timeline-slider__progress-bar-fill");
	// progressBar.appendChild(progressBarFill);
	// Generate titles and dots for each slide and append them
	slides.forEach((slide, index) => {
		const slideTitle = slide.querySelector(
			".timeline-slider__slide-title"
		).textContent;
		const slideId = slide.id;

		// Create the slide title navigation button
		const titleNavContainerItem = document.createElement("div");
		titleNavContainerItem.classList.add("timeline-slider__title-container");

		const titleNav = document.createElement("button");
		titleNav.classList.add("timeline-slider__nav-title");
		titleNav.textContent = slideTitle;
		titleNav.setAttribute("data-slide", index);
		titleNav.setAttribute("href", `#${slideId}`);
		titleNav.addEventListener("click", (e) => {
			e.preventDefault();

			if (index === slides.length - 1) {
				// logic for last slide (last slide gets clipped due to slide per view 1.3)
				swiper.slideTo(index, 0, true);
				setTimeout(() => {
					updateActiveDot(index);
					updateBackgroundColor(index);
				}, 50);
			} else {
				swiper.slideTo(index);
			}
		});

		// Create the navigation dot for the slide
		const dot = document.createElement("span");
		dot.classList.add("timeline-slider__dot");
		dot.setAttribute("data-slide", index);
		titleNavContainerItem.appendChild(titleNav);
		titleNavContainerItem.appendChild(dot);
		titleNavContainer.appendChild(titleNavContainerItem);
	});
	const titlesWrapper = document.createElement("div");
	titlesWrapper.classList.add("timeline-slider__titles-wrapper");

	// Create line
	const line = document.createElement("div");
	line.classList.add("timeline-slider__line");

	// Append nav and line to wrapper
	titlesWrapper.appendChild(line);
	titlesWrapper.appendChild(titleNavContainer);

	// Insert the title navigation container just below the .swiper-wrapper
	const intro = slider.querySelector(".timeline-slider__intro");
	if (intro) {
		intro.insertAdjacentElement("afterend", titlesWrapper);
	} else {
		slider.prepend(titlesWrapper);
	}

	// Insert arrow navigation
	slider.insertAdjacentHTML(
		"beforeend",
		`<nav class="timeline-slider__nav">
			<div class="swiper-button-prev">${prevSvg}</div>
			<div class="swiper-button-next">${nextSvg}</div>
			<div class="swiper-pagination"></div>
    	</nav>`
	);

	// Initialize the Swiper instance
	const swiper = new Swiper(slider, {
		direction: "horizontal",
		autoHeight: false,
		speed: 600,
		spaceBetween: 20,
		centeredSlides: true,
		slidesPerView: 1.3,
		cssMode: false,
		slideToClickedSlide: true,
		slidesOffsetBefore: 0,
		slidesOffsetAfter: 100,
		watchSlidesProgress: true,
		watchSlidesVisibility: true,
		slideVisibleClass: "swiper-slide-visible",
		keyboard: {
			enabled: true,
			onlyInViewport: true,
		},
		navigation: {
			prevEl: ".swiper-button-prev",
			nextEl: ".swiper-button-next",
		},
		pagination: {
			el: slider.querySelector(".swiper-pagination"),
			clickable: true,
			dynamicBullets: false,
			renderBullet: function (index, className) {
				// Limit bullet rendering to actual slides
				if (index >= slides.length) return "";
				return `<span class="${className}"></span>`;
			},
		},
		breakpoints: {
			0: {
				slidesPerView: 1,
				spaceBetween: 16,
				centeredSlides: false,
				slidesOffsetBefore: 0,
				slidesOffsetAfter: 0,
			},
			768: {
				slidesPerView: 1,
				spaceBetween: 20,
				centeredSlides: false,
			},
			1024: {
				slidesPerView: 1.3,
				spaceBetween: 30,
			},
		},

		on: {
			slideChange: () => {
				requestAnimationFrame(() => {
					let realIndex = swiper.activeIndex;
					const slideCount = swiper.slides.length;

					const nearEnd =
						realIndex >= slideCount - Math.ceil(swiper.params.slidesPerView);
					if (nearEnd && swiper.isEnd) {
						realIndex = slideCount - 1;
					}
					Array.from(swiper.slides).forEach((slide, index) => {
						if (index !== realIndex) {
							// Pause <audio> and <video>
							const mediaElements = slide.querySelectorAll("audio, video");
							mediaElements.forEach((el) => {
								if (!el.paused) {
									el.pause();
								}
							});

							// Pause embedded YouTube & Vimeo iframes
							const iframes = slide.querySelectorAll("iframe");
							iframes.forEach((iframe) => {
								const src = iframe.getAttribute("src") || "";

								// Pause YouTube
								if (src.includes("youtube.com") || src.includes("youtu.be")) {
									iframe.contentWindow?.postMessage(
										JSON.stringify({ event: "command", func: "pauseVideo" }),
										"*"
									);
								}

								// Pause Vimeo
								if (src.includes("vimeo.com")) {
									iframe.contentWindow?.postMessage({ method: "pause" }, "*");
								}
							});
							// Pause Apple Podcasts iframe by forcing reload
							const podcastIframes = slide.querySelectorAll(
								'iframe[src*="podcasts.apple.com"]'
							);
							podcastIframes.forEach((iframe) => {
								const src = iframe.getAttribute("src");
								iframe.setAttribute("src", src);
							});
						}
					});

					updateActiveDot(realIndex);
					updateBackgroundColor(realIndex);
					const activeSlide = swiper.slides[realIndex];
					if (activeSlide) {
						const iframes = activeSlide.querySelectorAll("iframe");
						iframes.forEach((iframe) => {
							const src = iframe.getAttribute("src") || "";

							// If it's a YouTube embed and doesn't have enablejsapi, add it
							if (
								src.includes("youtube.com") &&
								!src.includes("enablejsapi=1")
							) {
								const url = new URL(src, window.location.origin);
								url.searchParams.set("enablejsapi", "1");
								iframe.setAttribute("src", url.toString());
							}

							// Now send the pause command
							if (src.includes("youtube.com")) {
								iframe.contentWindow?.postMessage(
									JSON.stringify({ event: "command", func: "pauseVideo" }),
									"*"
								);
							}
						});
					}
				});
			},
		},
	});

	// Adjust offset after init to let last slide fully come into view

	const thisSlideWidth = slides[0].offsetWidth;
	if (window.innerWidth >= 768) {
		swiper.params.slidesOffsetAfter = thisSlideWidth * 0.3;
	} else {
		swiper.params.slidesOffsetAfter = 0;
	}

	// Function to update the active dot and title
	function updateActiveDot(activeIndex) {
		const titleNavItems = titleNavContainer.querySelectorAll(
			".timeline-slider__title-container"
		);

		titleNavItems.forEach((item, index) => {
			const dot = item.querySelector(".timeline-slider__dot");
			const title = item.querySelector(".timeline-slider__nav-title");

			dot.classList.remove("active");
			title.classList.remove("active");

			if (index === activeIndex) {
				dot.classList.add("active");
				title.classList.add("active");

				const containerScrollLeft = titleNavContainer.scrollLeft;
				const containerWidth = titleNavContainer.offsetWidth;
				const itemLeft = item.offsetLeft;
				const itemRight = itemLeft + item.offsetWidth;

				const buffer = 80; // increase for earlier scroll

				const visibleLeft = containerScrollLeft;
				const visibleRight = containerScrollLeft + containerWidth;

				let targetScroll = containerScrollLeft;

				// If the item is going out of view on the right
				if (itemRight + buffer > visibleRight) {
					targetScroll = itemRight - containerWidth + buffer;
				}
				// If the item is going out of view on the left
				else if (itemLeft - buffer < visibleLeft) {
					targetScroll = itemLeft - buffer;
				}

				titleNavContainer.scrollTo({
					left: Math.max(0, targetScroll),
					behavior: "smooth",
				});
			}
		});
	}

	// Function to update the background color of the parent container
	function updateBackgroundColor(activeIndex) {
		const activeSlide = slides[activeIndex];

		// Get the computed background color
		const computedBg = getComputedStyle(activeSlide).backgroundColor;

		// Extract the utility class (e.g. has-navy-dark-background-color)
		const classList = Array.from(activeSlide.classList);
		const bgClass = classList.find(
			(cls) => cls.startsWith("has-") && cls.endsWith("-background-color")
		);

		// Remove any existing has-*-background-color class from the slider
		Array.from(slider.classList).forEach((cls) => {
			if (cls.startsWith("has-") && cls.endsWith("-background-color")) {
				slider.classList.remove(cls);
			}
		});

		// Add the new one
		if (bgClass) {
			slider.classList.add(bgClass);
		}
	}

	const slideWidth = slides[0]?.offsetWidth || 0;
	swiper.params.slidesOffsetAfter = slideWidth * 0.3;
	swiper.update();

	// Initialize the background color on the first slide load
	updateBackgroundColor(swiper.activeIndex);
	updateActiveDot(swiper.activeIndex);
	// Function to update Swiper height based on tallest slide
	function setSwiperMaxHeight(sliderEl) {
		const wrapper = sliderEl.querySelector(".swiper-wrapper");
		const slides = wrapper?.querySelectorAll(".swiper-slide") || [];

		let maxHeight = 0;

		slides.forEach((slide) => {
			// Temporarily show all slides to measure accurately
			const prevDisplay = slide.style.display;
			slide.style.display = "block";

			const height = slide.offsetHeight;
			if (height > maxHeight) {
				maxHeight = height;
			}

			slide.style.display = prevDisplay; // revert
		});

		if (wrapper) {
			wrapper.style.height = `${maxHeight}px`;
		}
	}

	if (window.innerWidth > 768) {
		setSwiperMaxHeight(slider);
	}

	let resizeTimeout;
	window.addEventListener("resize", () => {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(() => {
			if (window.innerWidth > 768) {
				setSwiperMaxHeight(slider);
			} else {
				// Optional: Clear the height if you're switching to auto layout for mobile
				const wrapper = slider.querySelector(".swiper-wrapper");
				if (wrapper) {
					wrapper.style.height = "";
				}
			}
		}, 150);
	});
	swiper.update();
});
